import { AuthEffects } from "./auth/auth.effects";
import { CreatePositionEffects } from "./create-position/create-position.effects";
import { DashboardEffects } from "./dashboard/dashboard.effects";
import { OnboardingEffects } from "./onboarding/onboarding.effects";
import { UserEffects } from "./user/user.effects";

export const appEffects = [
  AuthEffects,
  UserEffects,
  OnboardingEffects,
  CreatePositionEffects,
  DashboardEffects
]